"use strict";

import { SCRIPT_ID, NO_CUUID_FOUND, TOO_MANY_SCRIPTS, BANNER_PREFERENCES, DIALOG_PREFERENCES } from "@/helpers/constants";
import { getElement } from "@/services/dom";

export function getCookiedockCuuid(name: string): string | void {
  const scriptTag: NodeListOf<HTMLElement> = document.querySelectorAll(SCRIPT_ID);
  if (scriptTag.length > 1) return console.warn(TOO_MANY_SCRIPTS);
  if (!scriptTag[0]?.dataset[name]) return console.warn(NO_CUUID_FOUND);
  return scriptTag[0]?.dataset[name];
}

export function allowOneDetailsOpen(selector: string): void {
  const details = getElement<HTMLDetailsElement>(selector, document, true);

  details.forEach((targetDetail) => {
    targetDetail.addEventListener("click", () => {
      details.forEach((detail) => {
        if (detail !== targetDetail) {
          detail.removeAttribute("open");
        }
      });
    });
  });
}

export function combineCheckboxes() {
  const inputs = getElement<HTMLInputElement>(`.${BANNER_PREFERENCES}`, document, true);
  const inputsDialog = getElement<HTMLDetailsElement>(`.${DIALOG_PREFERENCES}`, document, true);

  inputsDialog.forEach((element, index) => element.addEventListener("click", () => (inputs[index].checked = !element.open)));
  inputs.forEach((element, index) => element.addEventListener("change", () => (inputsDialog[index].open = element.checked)));
}

export function formatExpiry(expiry: string | number): string {
  if (typeof expiry === "string" && isNaN(Number(expiry))) {
    return expiry;
  }

  const expiryNum = Number(expiry);

  if (isNaN(expiryNum)) {
    return "Unknown";
  }

  if (expiryNum > 1000000000) {
    return new Date(expiryNum * 1000).toLocaleString("nl-NL", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  }

  if (expiryNum > 0) {
    const days = Math.floor(expiryNum / 86400);
    const hours = Math.floor((expiryNum % 86400) / 3600);
    const minutes = Math.floor((expiryNum % 3600) / 60);

    if (days > 0) {
      return `${days} day${days !== 1 ? "s" : ""}`;
    } else if (hours > 0) {
      return `${hours} hour${hours !== 1 ? "s" : ""}`;
    } else {
      return `${minutes} minute${minutes !== 1 ? "s" : ""}`;
    }
  }

  return "Session";
}
